import * as React from 'react';

import './FooterUIStyle.scss';

class FooterUI extends React.Component<{}, {}> {
    public render() {
        return (<div className="footer">
            <div className="footerBody">&#169; {(new Date()).getFullYear()} Chelsea FC</div>
        </div>);
    }
}

export default FooterUI;